export default __webpack_public_path__ + "static/media/message_logo.b42dbcfc.png";